<field-image-readonly *ngIf="field.readonly; else editable" [field]="field"></field-image-readonly>
<ng-template #editable>
  <field-image-single *ngIf="!field.multiple" [formGroup]="formGroup" [field]="field"></field-image-single>
  <field-image-multiple *ngIf="field.multiple" [formGroup]="formGroup" [field]="field"></field-image-multiple>
</ng-template>
